"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsUnknownDay = exports.getIsUnknownMonth = exports.parseValidationRelativeDate = exports.parseDateOperatorArgs = exports.resetUnknownDateParts = exports.todaysDateOperator = exports.restrictPastOperator = exports.restrictFutureOperator = exports.dateLessThanOperator = exports.dateLessThanOperatorMobileBug = exports.dateGreaterThanOperator = exports.dateGreaterThanOperatorMobileBug = exports.dateLessThanInclusiveOperator = exports.dateGreaterThanInclusiveOperator = exports.dateNotEqualToOperator = exports.dateEqualToOperator = void 0;
const dateConstants_1 = require("./dateConstants");
const datetime_1 = require("./datetime");
const datetimeQuestionParsing_1 = require("./datetimeQuestionParsing");
const graphql_1 = require("./types/graphql");
const dateEqualToOperator = (fact, json) => {
    const parsed = (0, exports.parseDateOperatorArgs)(fact, json);
    if (!parsed) {
        return;
    }
    const { factValue, jsonValue } = parsed;
    if (fact.type === graphql_1.DataTypeEnum.dateTime) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeDateAndTimeString)(jsonValue)) {
            return (0, datetime_1.isSameDate)(factValue, jsonValue);
        }
    }
    if (fact.type === graphql_1.DataTypeEnum.date) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeDateString)(jsonValue)) {
            const unknownMonth = (0, exports.getIsUnknownMonth)(fact, json);
            const unknownDay = (0, exports.getIsUnknownDay)(fact, json);
            const factDate = (0, exports.resetUnknownDateParts)(factValue, unknownMonth, unknownDay);
            const jsonDate = (0, exports.resetUnknownDateParts)(jsonValue, unknownMonth, unknownDay);
            return (0, datetime_1.isSameDate)(factDate, jsonDate);
        }
    }
    if (fact.type === graphql_1.DataTypeEnum.time) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeTimeString)(jsonValue)) {
            const today = (0, datetimeQuestionParsing_1.getTodayEnglishDateOnlyString)();
            const factDate = (0, datetimeQuestionParsing_1.convertTimeOnlyStringToDate)(factValue, today);
            const jsonDate = (0, datetimeQuestionParsing_1.convertTimeOnlyStringToDate)(jsonValue, today);
            return (0, datetime_1.isSameDate)(factDate, jsonDate);
        }
    }
};
exports.dateEqualToOperator = dateEqualToOperator;
const dateNotEqualToOperator = (fact, json) => {
    const parsed = (0, exports.parseDateOperatorArgs)(fact, json);
    if (!parsed) {
        return;
    }
    const { factValue, jsonValue } = parsed;
    if (fact.type === graphql_1.DataTypeEnum.dateTime) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeDateAndTimeString)(jsonValue)) {
            return !(0, datetime_1.isSameDate)(factValue, jsonValue);
        }
    }
    if (fact.type === graphql_1.DataTypeEnum.date) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeDateString)(jsonValue)) {
            const unknownMonth = (0, exports.getIsUnknownMonth)(fact, json);
            const unknownDay = (0, exports.getIsUnknownDay)(fact, json);
            const factDate = (0, exports.resetUnknownDateParts)(factValue, unknownMonth, unknownDay);
            const jsonDate = (0, exports.resetUnknownDateParts)(jsonValue, unknownMonth, unknownDay);
            return !(0, datetime_1.isSameDate)(factDate, jsonDate);
        }
    }
    if (fact.type === graphql_1.DataTypeEnum.time) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeTimeString)(jsonValue)) {
            const today = (0, datetimeQuestionParsing_1.getTodayEnglishDateOnlyString)();
            const factDate = (0, datetimeQuestionParsing_1.convertTimeOnlyStringToDate)(factValue, today);
            const jsonDate = (0, datetimeQuestionParsing_1.convertTimeOnlyStringToDate)(jsonValue, today);
            return !(0, datetime_1.isSameDate)(factDate, jsonDate);
        }
    }
};
exports.dateNotEqualToOperator = dateNotEqualToOperator;
const dateGreaterThanInclusiveOperator = (fact, json) => {
    const parsed = (0, exports.parseDateOperatorArgs)(fact, json);
    if (!parsed) {
        return;
    }
    const { factValue, jsonValue } = parsed;
    if (fact.type === graphql_1.DataTypeEnum.dateTime) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeDateAndTimeString)(jsonValue)) {
            return (0, datetime_1.isSameOrAfterDate)(factValue, jsonValue);
        }
    }
    if (fact.type === graphql_1.DataTypeEnum.date) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeDateString)(jsonValue)) {
            const unknownMonth = (0, exports.getIsUnknownMonth)(fact, json);
            const unknownDay = (0, exports.getIsUnknownDay)(fact, json);
            const factDate = (0, exports.resetUnknownDateParts)(factValue, unknownMonth, unknownDay);
            const jsonDate = (0, exports.resetUnknownDateParts)(jsonValue, unknownMonth, unknownDay);
            return (0, datetime_1.isSameOrAfterDate)(factDate, jsonDate);
        }
    }
    if (fact.type === graphql_1.DataTypeEnum.time) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeTimeString)(jsonValue)) {
            const today = (0, datetimeQuestionParsing_1.getTodayEnglishDateOnlyString)();
            const factDate = (0, datetimeQuestionParsing_1.convertTimeOnlyStringToDate)(factValue, today);
            const jsonDate = (0, datetimeQuestionParsing_1.convertTimeOnlyStringToDate)(jsonValue, today);
            return (0, datetime_1.isSameOrAfterDate)(factDate, jsonDate);
        }
    }
};
exports.dateGreaterThanInclusiveOperator = dateGreaterThanInclusiveOperator;
const dateLessThanInclusiveOperator = (fact, json) => {
    const parsed = (0, exports.parseDateOperatorArgs)(fact, json);
    if (!parsed) {
        return;
    }
    const { factValue, jsonValue } = parsed;
    if (fact.type === graphql_1.DataTypeEnum.dateTime) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeDateAndTimeString)(jsonValue)) {
            return (0, datetime_1.isSameOrBeforeDate)(factValue, jsonValue);
        }
    }
    if (fact.type === graphql_1.DataTypeEnum.date) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeDateString)(jsonValue)) {
            const unknownMonth = (0, exports.getIsUnknownMonth)(fact, json);
            const unknownDay = (0, exports.getIsUnknownDay)(fact, json);
            const factDate = (0, exports.resetUnknownDateParts)(factValue, unknownMonth, unknownDay);
            const jsonDate = (0, exports.resetUnknownDateParts)(jsonValue, unknownMonth, unknownDay);
            return (0, datetime_1.isSameOrBeforeDate)(factDate, jsonDate);
        }
    }
    if (fact.type === graphql_1.DataTypeEnum.time) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeTimeString)(jsonValue)) {
            const today = (0, datetimeQuestionParsing_1.getTodayEnglishDateOnlyString)();
            const factDate = (0, datetimeQuestionParsing_1.convertTimeOnlyStringToDate)(factValue, today);
            const jsonDate = (0, datetimeQuestionParsing_1.convertTimeOnlyStringToDate)(jsonValue, today);
            return (0, datetime_1.isSameOrBeforeDate)(factDate, jsonDate);
        }
    }
};
exports.dateLessThanInclusiveOperator = dateLessThanInclusiveOperator;
const dateGreaterThanOperatorMobileBug = (fact, json) => {
    return _dateGreaterThanOperator(fact, json, true);
};
exports.dateGreaterThanOperatorMobileBug = dateGreaterThanOperatorMobileBug;
const dateGreaterThanOperator = (fact, json) => {
    return _dateGreaterThanOperator(fact, json, false);
};
exports.dateGreaterThanOperator = dateGreaterThanOperator;
const _dateGreaterThanOperator = (fact, json, emulateMobileBug) => {
    const parsed = (0, exports.parseDateOperatorArgs)(fact, json);
    if (!parsed) {
        return;
    }
    let { factValue, jsonValue } = parsed;
    const relativeDate = (0, exports.parseValidationRelativeDate)(jsonValue);
    if (fact.type === graphql_1.DataTypeEnum.dateTime) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeDateAndTimeString)(jsonValue)) {
            return (0, datetime_1.isAfterDate)(factValue, jsonValue);
        }
        else if (relativeDate) {
            return (0, datetime_1.isAfterDate)(factValue, relativeDate);
        }
    }
    if (fact.type === graphql_1.DataTypeEnum.date) {
        const dateFormat = emulateMobileBug ? dateConstants_1.normalizedDateFormatMobile : dateConstants_1.normalizedDateFormat;
        const unknownMonth = (0, exports.getIsUnknownMonth)(fact, json);
        const unknownDay = (0, exports.getIsUnknownDay)(fact, json);
        factValue = (0, exports.resetUnknownDateParts)(factValue, unknownMonth, unknownDay);
        if ((0, datetimeQuestionParsing_1.isValidDateTimeDateString)(jsonValue) || (0, datetimeQuestionParsing_1.isValidDateTimeDateAndTimeString)(jsonValue)) {
            jsonValue = (0, exports.resetUnknownDateParts)(jsonValue, unknownMonth, unknownDay, dateFormat);
            return (0, datetime_1.isAfterDate)(factValue, jsonValue);
        }
        else if (relativeDate) {
            const compareDate = (0, exports.resetUnknownDateParts)(relativeDate, unknownMonth, unknownDay, dateFormat);
            return (0, datetime_1.isAfterDate)(factValue, compareDate);
        }
    }
    if (fact.type === graphql_1.DataTypeEnum.time) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeTimeString)(jsonValue)) {
            const today = (0, datetimeQuestionParsing_1.getTodayEnglishDateOnlyString)();
            const factDate = (0, datetimeQuestionParsing_1.convertTimeOnlyStringToDate)(factValue, today);
            const jsonDate = (0, datetimeQuestionParsing_1.convertTimeOnlyStringToDate)(jsonValue, today);
            return (0, datetime_1.isAfterDate)(factDate, jsonDate);
        }
        else if ((0, datetimeQuestionParsing_1.isValidDateTimeDateAndTimeString)(jsonValue)) {
            return (0, datetime_1.isAfterDate)(factValue, jsonValue);
        }
        else if (relativeDate) {
            return (0, datetime_1.isAfterDate)(factValue, relativeDate);
        }
    }
};
const dateLessThanOperatorMobileBug = (fact, json) => {
    return _dateLessThanOperator(fact, json, true);
};
exports.dateLessThanOperatorMobileBug = dateLessThanOperatorMobileBug;
const dateLessThanOperator = (fact, json) => {
    return _dateLessThanOperator(fact, json, false);
};
exports.dateLessThanOperator = dateLessThanOperator;
const _dateLessThanOperator = (fact, json, emulateMobileBug) => {
    const parsed = (0, exports.parseDateOperatorArgs)(fact, json);
    if (!parsed) {
        return;
    }
    let { factValue, jsonValue } = parsed;
    const relativeDate = (0, exports.parseValidationRelativeDate)(jsonValue);
    if (fact.type === graphql_1.DataTypeEnum.dateTime) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeDateAndTimeString)(jsonValue)) {
            return (0, datetime_1.isBeforeDate)(factValue, jsonValue);
        }
        else if (relativeDate) {
            return (0, datetime_1.isBeforeDate)(factValue, relativeDate);
        }
    }
    if (fact.type === graphql_1.DataTypeEnum.date) {
        const dateFormat = emulateMobileBug ? dateConstants_1.normalizedDateFormatMobile : dateConstants_1.normalizedDateFormat;
        const unknownMonth = (0, exports.getIsUnknownMonth)(fact, json);
        const unknownDay = (0, exports.getIsUnknownDay)(fact, json);
        factValue = (0, exports.resetUnknownDateParts)(factValue, unknownMonth, unknownDay);
        if ((0, datetimeQuestionParsing_1.isValidDateTimeDateString)(jsonValue) || (0, datetimeQuestionParsing_1.isValidDateTimeDateAndTimeString)(jsonValue)) {
            jsonValue = (0, exports.resetUnknownDateParts)(jsonValue, unknownMonth, unknownDay, dateFormat);
            return (0, datetime_1.isBeforeDate)(factValue, jsonValue);
        }
        else if (relativeDate) {
            const compareDate = (0, exports.resetUnknownDateParts)(relativeDate, unknownMonth, unknownDay, dateFormat);
            return (0, datetime_1.isBeforeDate)(factValue, compareDate);
        }
    }
    if (fact.type === graphql_1.DataTypeEnum.time) {
        if ((0, datetimeQuestionParsing_1.isValidDateTimeTimeString)(jsonValue)) {
            const today = (0, datetimeQuestionParsing_1.getTodayEnglishDateOnlyString)();
            const factDate = (0, datetimeQuestionParsing_1.convertTimeOnlyStringToDate)(factValue, today);
            const jsonDate = (0, datetimeQuestionParsing_1.convertTimeOnlyStringToDate)(jsonValue, today);
            return (0, datetime_1.isBeforeDate)(factDate, jsonDate);
        }
        else if ((0, datetimeQuestionParsing_1.isValidDateTimeDateAndTimeString)(jsonValue)) {
            return (0, datetime_1.isBeforeDate)(factValue, jsonValue);
        }
        else if (relativeDate) {
            return (0, datetime_1.isBeforeDate)(factValue, relativeDate);
        }
    }
};
const restrictFutureOperator = (factValue) => {
    if (!factValue) {
        return false;
    }
    const date = (0, datetime_1.setSeconds)(0, factValue);
    const dateOnly = (0, datetime_1.getHours)(date) === 0 && (0, datetime_1.getMinutes)(date) === 0;
    const now = dateOnly ? (0, datetime_1.endOfDate)(new Date(), 'day') : (0, datetime_1.setSeconds)(0);
    return (0, datetime_1.isAfterDate)(date, now);
};
exports.restrictFutureOperator = restrictFutureOperator;
const restrictPastOperator = (factValue) => {
    if (!factValue) {
        return false;
    }
    const date = (0, datetime_1.setSeconds)(0, factValue);
    const dateOnly = (0, datetime_1.getHours)(date) === 0 && (0, datetime_1.getMinutes)(date) === 0;
    const now = dateOnly ? (0, datetime_1.startOfDate)(new Date(), 'day') : (0, datetime_1.setSeconds)(0);
    return (0, datetime_1.isBeforeDate)(date, now);
};
exports.restrictPastOperator = restrictPastOperator;
const todaysDateOperator = (factValue) => {
    return factValue && !(0, datetime_1.isSameDate)(factValue, new Date(), 'day');
};
exports.todaysDateOperator = todaysDateOperator;
// If originalDate specifies anything below days (hours, minutes, ...) that will be ignored
// since this information is not available for a date-only value
const resetUnknownDateParts = (originalDate, unknownMonth, unknownDay, dateFormat = dateConstants_1.normalizedDateFormat) => {
    let result = (0, datetime_1.getDateInstance)(originalDate);
    if (unknownMonth) {
        result = (0, datetime_1.setMonth)(0, result);
        result = (0, datetime_1.setDate)(1, result);
    }
    else if (unknownDay) {
        result = (0, datetime_1.setDate)(1, result);
    }
    return (0, datetime_1.formatDate)(dateFormat, result);
};
exports.resetUnknownDateParts = resetUnknownDateParts;
const parseDateOperatorArgs = (fact, json) => {
    if (!fact?.value || (!isString(json) && !json?.value)) {
        return;
    }
    const factValue = fact.value;
    const jsonValue = isString(json) ? json : json.value;
    return { factValue, jsonValue };
};
exports.parseDateOperatorArgs = parseDateOperatorArgs;
const parseValidationRelativeDate = (jsonValue) => {
    let parsedDate;
    try {
        parsedDate = JSON.parse(jsonValue) || {};
    }
    catch {
        return;
    }
    if (!parsedDate || Object.keys(parsedDate).length === 0 || !['before', 'after'].includes(parsedDate.relative)) {
        return;
    }
    const { relative, dateTime } = parsedDate;
    const { years, days, hours, minutes } = dateTime || {};
    let compareDate;
    if (relative === 'before') {
        compareDate = (0, datetime_1.subtractDate)(years || 0, 'years', compareDate);
        compareDate = (0, datetime_1.subtractDate)(days || 0, 'days', compareDate);
        compareDate = (0, datetime_1.subtractDate)(hours || 0, 'hours', compareDate);
        compareDate = (0, datetime_1.subtractDate)(minutes || 0, 'minutes', compareDate);
    }
    else if (relative === 'after') {
        compareDate = (0, datetime_1.addDate)(years || 0, 'years', compareDate);
        compareDate = (0, datetime_1.addDate)(days || 0, 'days', compareDate);
        compareDate = (0, datetime_1.addDate)(hours || 0, 'hours', compareDate);
        compareDate = (0, datetime_1.addDate)(minutes || 0, 'minutes', compareDate);
    }
    else {
        compareDate = new Date();
    }
    return compareDate;
};
exports.parseValidationRelativeDate = parseValidationRelativeDate;
const getIsUnknownMonth = (fact, json) => {
    return fact.unknownMonth || (typeof json === 'object' && json.unknownMonth);
};
exports.getIsUnknownMonth = getIsUnknownMonth;
const getIsUnknownDay = (fact, json) => {
    return fact.unknownDay || (typeof json === 'object' && json.unknownDay);
};
exports.getIsUnknownDay = getIsUnknownDay;
const isString = (x) => x != null && typeof x.valueOf() === 'string';
